/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import { ForgotPassword } from './components/ForgotPassword';
import { Login } from './components/Login';
import { ResetPassword } from './components/ResetPassword';
import { Registration } from './components/Registration';
import ActivateAcount from './components/ActivateAcount';
import FloatingChatbot from '../../../components/Chatbot/FloatingChatbot';

const AuthLayout = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    document.body.classList.add('bg-gradient-primary');
    
    // Add loading delay for smooth animation
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    return () => {
      document.body.classList.remove('bg-gradient-primary');
    };
  }, []);

  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerText = `
      /* Stunning Attractive Background */
      .bg-gradient-primary {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 25%, #f093fb 50%, #f5576c 75%, #4facfe 100%);
        min-height: 100vh;
        position: relative;
        overflow: hidden;
        animation: gradientShift 8s ease infinite;
      }

      .bg-gradient-primary::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: 
          radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.3) 0%, transparent 40%),
          radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.2) 0%, transparent 50%),
          radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 60%);
        animation: lightShift 6s ease-in-out infinite;
        z-index: 0;
      }

      .bg-gradient-primary::after {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: 
          linear-gradient(45deg, rgba(255, 255, 255, 0.1) 25%, transparent 25%),
          linear-gradient(-45deg, rgba(255, 255, 255, 0.1) 25%, transparent 25%);
        background-size: 60px 60px;
        animation: patternFloat 10s linear infinite;
        z-index: 0;
      }

      /* Beautiful Floating Elements */
      .floating-shapes {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 1;
      }

      .floating-shapes .shape {
        position: absolute;
        background: linear-gradient(45deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.2));
        border: 1px solid rgba(255, 255, 255, 0.4);
        backdrop-filter: blur(10px);
        box-shadow: 0 8px 32px rgba(255, 255, 255, 0.3);
        animation: floatBeautiful 8s ease-in-out infinite;
      }

      .floating-shapes .shape:nth-child(1) {
        width: 100px;
        height: 100px;
        top: 15%;
        left: 10%;
        border-radius: 50%;
        animation-delay: 0s;
        background: linear-gradient(45deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.2));
      }

      .floating-shapes .shape:nth-child(2) {
        width: 80px;
        height: 80px;
        top: 60%;
        left: 85%;
        border-radius: 20px;
        animation-delay: 2s;
        background: linear-gradient(45deg, rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0.2));
      }

      .floating-shapes .shape:nth-child(3) {
        width: 120px;
        height: 120px;
        top: 80%;
        left: 20%;
        border-radius: 50%;
        animation-delay: 4s;
        background: linear-gradient(45deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.15));
      }

      .floating-shapes .shape:nth-child(4) {
        width: 60px;
        height: 60px;
        top: 5%;
        left: 75%;
        border-radius: 50%;
        animation-delay: 6s;
        background: linear-gradient(45deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.2));
      }

      .floating-shapes .shape:nth-child(5) {
        width: 90px;
        height: 90px;
        top: 40%;
        left: 5%;
        border-radius: 30px;
        animation-delay: 1s;
        background: linear-gradient(45deg, rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0.2));
      }

      .floating-shapes .shape:nth-child(6) {
        width: 70px;
        height: 70px;
        top: 25%;
        left: 60%;
        border-radius: 50%;
        animation-delay: 3s;
        background: linear-gradient(45deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.15));
      }


      /* Enhanced Logo Container - Perfectly Centered */
      .logo-container {
        position: relative;
        z-index: 15;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto 2rem auto;
        width: 100%;
        text-align: center;
        transform: scale(0) translateY(-50px);
        opacity: 0;
        animation: logoEntrance 1.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) 0.5s forwards;
      }

      .logo-container img {
        height: 100px;
        width: auto;
        max-width: 300px;
        display: block;
        margin: 0 auto;
        transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        filter: drop-shadow(0 15px 30px rgba(0, 0, 0, 0.3));
        animation: logoGlow 3s ease-in-out infinite alternate;
        object-fit: contain;
        object-position: center;
      }

      .logo-container:hover img {
        transform: scale(1.1) translateY(-5px);
        filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.4));
      }

      /* Stunning Glassmorphism Card */
      .auth-card-wrapper {
        position: relative;
        z-index: 10;
        transform: translateY(50px) scale(0.95);
        opacity: 0;
        animation: cardSlideIn 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.8s forwards;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60%;
      }

      .auth-card {
        background: rgba(255, 255, 255, 0.25);
        backdrop-filter: blur(20px);
        border: 1px solid rgba(255, 255, 255, 0.4);
        border-radius: 24px;
        box-shadow: 
          0 25px 50px rgba(0, 0, 0, 0.2),
          inset 0 1px 0 rgba(255, 255, 255, 0.4);
        transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        max-width: 500px;
        width: 60%;
        padding: 3rem;
        position: relative;
        margin: 0 auto;
        overflow: hidden;
      }

      .auth-card::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
      }

      .auth-card:hover {
        transform: translateY(-8px) scale(1.02);
        box-shadow: 
          0 35px 70px rgba(0, 0, 0, 0.25),
          inset 0 1px 0 rgba(255, 255, 255, 0.5);
        border-color: rgba(255, 255, 255, 0.5);
        background: rgba(255, 255, 255, 0.3);
      }

      .auth-card::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
      }

      .auth-card:hover {
        transform: translateY(-8px) scale(1.02);
        box-shadow: 
          0 35px 70px rgba(0, 0, 0, 0.2),
          inset 0 1px 0 rgba(255, 255, 255, 0.3);
        border-color: rgba(255, 255, 255, 0.4);
      }

      .auth-card:hover::before {
        animation: shimmer 2s ease-in-out infinite;
      }

      /* Loading Animation */
      .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%; 
        background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        opacity: 1;
        transition: opacity 0.5s ease;
      }

      .loading-overlay.fade-out {
        opacity: 0;
        pointer-events: none;
      }

      .loading-spinner {
        width: 60px;
        height: 60px;
        border: 4px solid rgba(255, 255, 255, 0.3);
        border-top: 4px solid white;
        border-radius: 50%;
        animation: spin 1s linear infinite;
      }

      /* Beautiful Animations */
      @keyframes gradientShift {
        0%, 100% { 
          background-position: 0% 50%; 
        }
        50% { 
          background-position: 100% 50%; 
        }
      }

      @keyframes lightShift {
        0%, 100% { 
          transform: translateX(0) translateY(0) scale(1); 
        }
        33% { 
          transform: translateX(20px) translateY(-10px) scale(1.1); 
        }
        66% { 
          transform: translateX(-15px) translateY(15px) scale(0.9); 
        }
      }

      @keyframes patternFloat {
        0% { 
          transform: translateX(0) translateY(0); 
        }
        100% { 
          transform: translateX(60px) translateY(60px); 
        }
      }

      @keyframes floatBeautiful {
        0% { 
          transform: translateY(0px) translateX(0px) rotate(0deg) scale(1); 
        }
        25% { 
          transform: translateY(-30px) translateX(20px) rotate(5deg) scale(1.1); 
        }
        50% { 
          transform: translateY(-50px) translateX(-10px) rotate(-3deg) scale(0.9); 
        }
        75% { 
          transform: translateY(-20px) translateX(25px) rotate(2deg) scale(1.05); 
        }
        100% { 
          transform: translateY(0px) translateX(0px) rotate(0deg) scale(1); 
        }
      }

      @keyframes logoEntrance {
        0% { 
          transform: scale(0) translateY(-50px) rotate(-180deg); 
          opacity: 0; 
        }
        50% { 
          transform: scale(1.3) translateY(-10px) rotate(0deg); 
          opacity: 0.8; 
        }
        100% { 
          transform: scale(1) translateY(0) rotate(0deg); 
          opacity: 1; 
        }
      }

      @keyframes logoGlow {
        0% {
          filter: drop-shadow(0 15px 30px rgba(0, 0, 0, 0.3));
        }
        100% {
          filter: drop-shadow(0 20px 40px rgba(102, 126, 234, 0.4));
        }
      }

      @keyframes cardSlideIn {
        0% { 
          transform: translateY(50px) scale(0.95); 
          opacity: 0; 
        }
        50% { 
          transform: translateY(-10px) scale(1.02); 
          opacity: 0.8; 
        }
        100% { 
          transform: translateY(0) scale(1); 
          opacity: 1; 
        }
      }

      @keyframes shimmer {
        0% { 
          transform: translateX(-100%); 
        }
        100% { 
          transform: translateX(100%); 
        }
      }

      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }

      /* Responsive Design */
      @media (max-width: 1024px) {
        .auth-card-wrapper {
          width: 75%;
        }
        
        .auth-card {
          max-width: 450px;
        }
      }

      @media (max-width: 768px) {
        .floating-shapes .shape:nth-child(n+2) {
          display: none;
        }

        .auth-card-wrapper {
          width: 85%;
        }

        .logo-container {
          margin: 0 auto 1.5rem auto;
        }

        .logo-container img {
          height: 80px;
          max-width: 250px;
        }

        .auth-card {
          margin: 1rem;
          padding: 2rem;
          max-width: 100%;
          width: 100%;
        }
      }

      @media (max-width: 480px) {
        .auth-card-wrapper {
          width: 95%;
        }

        .logo-container {
          margin: 0 auto 1rem auto;
        }

        .logo-container img {
          height: 70px;
          max-width: 200px;
        }

        .auth-card {
          margin: 0.5rem;
          padding: 1.5rem;
          max-width: 100%;
          width: 100%;
        }
      }

      @media (max-width: 360px) {
        .auth-card-wrapper {
          width: 98%;
        }

        .auth-card {
          margin: 0.25rem;
          padding: 1rem;
        }
      }
    `;
    document.head.appendChild(styleSheet);
  
    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);
  

  return (
    <div className='d-flex flex-column flex-column-fluid position-relative' style={{ height: '100vh' }}>
      {/* Loading Overlay */}
      {!isLoaded && (
        <div className='loading-overlay'>
          <div className='loading-spinner'></div>
        </div>
      )}
      
      {/* Beautiful Background Elements */}
      <div className='floating-shapes'>
        <div className='shape'></div>
        <div className='shape'></div>
        <div className='shape'></div>
        <div className='shape'></div>
        <div className='shape'></div>
        <div className='shape'></div>
      </div>
      
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Logo */}
        <div className='logo-container'>
          <a href='#' className='d-flex align-items-center justify-content-center'>
            <img
              alt='Maarefati Logo'
              src={toAbsoluteUrl('/media/logos/maarefati-logo.png')}
            />
          </a>
        </div>
        {/* end::Logo */}
        
        {/* begin::Auth Card */}
        <div className='auth-card-wrapper'>
          <div className='auth-card'>
            <Outlet />
          </div>
        </div>
        {/* end::Auth Card */}
      </div>
      {/* end::Content */}
      <FloatingChatbot />
    </div>
  );
}

const RegistrationLayout = () => {
  useEffect(() => {
    return () => {
      // Cleanup if needed
    };
  }, []);

  return (
    <div className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'>
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Logo */}
        <a href='#' className='mb-12 d-flex align-items-center gap-3'>
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/logos/maarefati-logo.png')}
            className='h-75px'
          />
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper with rotating background */}
        <div className='auth-card-wrapper'>
          <div className='w-xl-1000px w-lg-800px w-md-650px w-100 rounded shadow-sm mx-auto'>
            <Outlet />
          </div>
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      <FloatingChatbot />
    </div>
  );
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='reset-password/:token' element={<ResetPassword />} />
      <Route path='activate/:token' element={<ActivateAcount />} />
      <Route index element={<Login />} />
    </Route>
    <Route element={<RegistrationLayout />}>
      <Route path='registration' element={<Registration />} />
    </Route>
  </Routes>
);

export default AuthPage;
